import EpisodicProp from './episodic-prop.entity';
import { SosListResponse } from '../sos-response';
import { EpisodicBaseESDoc } from '../types';

export interface EpisodicPropESDoc extends EpisodicBaseESDoc {
	name: string;
	brand: string;
	color: string;
	description: string;
	char_first_name: string;
	char_last_name: string;
	char_num: string;
	ep_char_id: number;
}

export interface EpisodicPropsForCharacterListResponse extends SosListResponse {
	listed: {
		EpisodicProp: EpisodicProp[];
	};
}

export interface EpisodicPropsWithoutCharacterListResponse {
	listed: {
		EpisodicProp: EpisodicProp[];
	};
}
